import { type ReactElement } from 'react';

/**
 * One line-drawn glyph per menu entry (24px grid, 1.8 stroke, the merchant space's icon style). Decorative: the label
 * beside it is the accessible name.
 */
const PATHS: Record<string, string> = {
  '/dashboard': 'M4 13h6V4H4zM14 20h6v-9h-6zM4 20h6v-3H4zM14 7h6V4h-6z',
  '/merchants':
    'M4 9l1.5-5h13L20 9M4 9h16v2a3 3 0 0 1-5.33 1.9A3 3 0 0 1 12 14a3 3 0 0 1-2.67-1.1A3 3 0 0 1 4 11zM5 14v6h14v-6',
  '/portfolios': 'M4 7h16v12H4zM9 7V5h6v2M4 12h16',
  '/administrators': 'M12 3l7 3v5c0 4.5-3 8-7 10-4-2-7-5.5-7-10V6zM9.5 12l1.8 1.8L15 10',
  '/access': 'M8 11V8a4 4 0 0 1 8 0v3M6 11h12v9H6zM12 15v2',
  '/security': 'M4 6h16M4 12h10M4 18h7M17 15l2 2 3-4',
  '/organisations': 'M12 5v14M5 12h14',
  '/analytics': 'M4 20V10M10 20V4M16 20v-7M22 20H2',
  '/account': 'M12 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8zM4 21a8 8 0 0 1 16 0',
};

export function NavIcon({ to }: { to: string }): ReactElement | null {
  const d = PATHS[to];
  if (d === undefined) return null;
  return (
    <svg
      aria-hidden="true"
      viewBox="0 0 24 24"
      width="18"
      height="18"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="shrink-0"
    >
      <path d={d} />
    </svg>
  );
}
